import * as React from 'react';

// Taken from: https://gist.github.com/rikukissa/cb291a4a82caa670d2e0547c520eae53
export function useAddToHomescreenPrompt() {
  const [prompt, setState] = React.useState<any>(null);

  const promptToInstall = () => {
    if (prompt) {
      return prompt.prompt();
    }
    return Promise.reject(
      new Error(
        'Tried installing before browser sent "beforeinstallprompt" event',
      ),
    );
  };

  React.useEffect(() => {
    const ready = (e: any) => {
      e.preventDefault();
      setState(e);
    };

    window.addEventListener('beforeinstallprompt', ready);

    return () => {
      window.removeEventListener('beforeinstallprompt', ready);
    };
  }, []);

  return { prompt, promptToInstall };
}

export const useIsPWAInstalled = () => {
  const [isAppInstalled, setIsAppInstalled] = React.useState(false);

  React.useEffect(() => {
    isPWAInstalled();
  }, []);

  const isPWAInstalled = async () => {
    if ('getInstalledRelatedApps' in window.navigator) {
      const relatedApps = await (navigator as any).getInstalledRelatedApps();
      let installed = false;
      relatedApps.forEach((app: any) => {
        //if your PWA exists in the array it is installed
        console.log(app.platform, app.url);
        if (app.url === 'https://app.hikos.eu/manifest.json') {
          installed = true;
        }
      });
      setIsAppInstalled(installed);
    }
  };
  return { isAppInstalled };
};
